<template>
  <v-container v-scroll="onScroll" class="px-3 px-sm-6 mt-2" fluid>
    <div>
      <v-row class="mb-12">
        <v-col cols="12">
          <v-row class="align-end" no-gutters>
            <v-col cols="12" sm="8" lg="10">
              <h1 class="text-h4 font-weight-bold">Albums</h1>
              <h2 class="text-subtitle-1 mb-0">
                Browse through latest User's Albums
                <v-dialog v-model="albumsDialog" width="400">
                  <template #activator="{ on }">
                    <v-btn icon small class="ml-2" v-on="on">
                      <v-icon small>fal fa-info-circle</v-icon>
                    </v-btn>
                  </template>
                  <v-card outlined>
                    <v-card-title class="text-h5" primary-title>
                      What are albums?
                    </v-card-title>
                    <v-card-text>
                      <p>
                        Albums is a feature that allows you to create your own
                        visual style.
                      </p>
                      <p>
                        100ASA members will have the ability to browse your
                        albums making them more discoverable within the
                        community.
                      </p>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text small @click="albumsDialog = false">
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </h2>
            </v-col>
            <v-col class="text-right" cols="12" sm="4" lg="2">
              <!-- <Filters
                :categories="categories"
                :on-apply="onApply"
                from="elite"
              /> -->
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-for="(album, index) in list"
          :key="index"
          cols="12"
          sm="6"
          md="4"
          lg="3"
        >
          <v-card outlined>
            <nuxt-link
              :to="
                `/albums/${album.id}/${album.slug}?from=albums&st=${offsetTop}`
              "
              nuxt
            >
              <v-img
                v-if="album.thumbnail"
                :src="album.thumbnail"
                :height="250"
                class="album-thumbnail"
              />
            </nuxt-link>
            <v-card-title primary-title>
              <div class="w-100-percentage text-center">
                <nuxt-link
                  :to="
                    `/albums/${album.id}/${album.slug}?from=albums&st=${offsetTop}`
                  "
                  class="no-underline"
                  nuxt
                >
                  <h3 class="text-h6 font-weight-bold text-truncate">
                    {{ album.title }}
                  </h3>
                </nuxt-link>
              </div>
            </v-card-title>
            <v-card-subtitle>
              <div class="text-center">
                <h4 class="text-body-2 mb-2">
                  {{ album.totalNumberOfPhotos }} photo{{
                    album.totalNumberOfPhotos === 1 ? '' : 's'
                  }}
                </h4>
              </div>
              <div class="w-100-percentage d-flex align-center justify-center">
                <span class="text-body-2 mr-1">by</span>
                <nuxt-link
                  :to="
                    `/photographer/${album.ownerUserName || album.ownerUserId}`
                  "
                  class="no-underline text-caption"
                  nuxt
                >
                  <h5 class="text-body-2 font-weight-bold text-truncate">
                    {{ album.ownerFullName }}
                  </h5>
                </nuxt-link>
              </div>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <div v-intersect="onIntersect" />
      <div v-if="loading" class="text-center">
        <v-icon class="fa-spin my-3"> fal fa-spinner </v-icon>
      </div>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment'
import goTo from 'vuetify/lib/services/goto'
import { mapState } from 'vuex'

export default {
  middleware: 'header',
  data() {
    return {
      loading: false,
      offsetTop: 0,
      albumsDialog: false
    }
  },
  head({ $seo }) {
    return $seo({
      title: 'Albums',
      description: "Find inspiration. Check 100ASA's albums. Discover photo ideas. Photographers' portfolio."
    })
  },
  computed: {
    ...mapState({
      me: state => state.auth.user,
      list: state => state.albums.list,
      page: state => state.albums.listPage,
      isLastPage: state => state.albums.listIsLastPage,
      loadDate: state => state.albums.listLoadDate
    })
  },
  async mounted() {
    // Reload the albums after 30 minutes in cache
    if (
      !this.loadDate ||
      moment().isAfter(moment(this.loadDate).add(30, 'minutes'))
    ) {
      await this.$store.dispatch('albums/resetStore')
    }

    // const reload = this.$asa.checkAndSetTagsAndCategory(
    //   this.selectedTags,
    //   this.selectedCategoryText
    // )

    if (this.list.length === 0 && !this.isLastPage /* || reload */) {
      const data = {
        page: 1
      }
      try {
        this.loading = true
        await this.$store.dispatch('albums/resetStore')
        await this.$store.dispatch('albums/getAlbums', data)
        const date = new Date()
        await this.$store.dispatch('albums/setAlbumsLoadDate', moment(date))
      } catch (error) {
        this.$asa.appInsights('Pages: albums/index.vue - method: mounted', error)
      } finally {
        this.loading = false
      }
    }
    if (
      this.$route.query.back === 'yes' &&
      this.$route.query.st &&
      this.list.length > 0
    ) {
      goTo(Number(this.$route.query.st))
    }
  },
  methods: {
    onIntersect(entries) {
      if (
        entries[0].intersectionRatio > 0 &&
        this.list.length > 0 &&
        !this.isLastPage &&
        !this.loading
      ) {
        this.loadMore()
      }
    },
    async loadMore() {
      this.loading = true
      try {
        await this.$store.dispatch('albums/getAlbums', {
          page: this.page + 1
        })
      } catch (error) {
        this.$asa.appInsights('Pages: albums/index.vue - method: loadMore', error)
      } finally {
        this.loading = false
      }
    },
    // getQueries() {
    //   const q = this.$route.query
    //   let query = ''
    //   query += `&st=${this.offsetTop}`
    //   if (q.category) query += `&category=${q.category}`
    //   if (q.tags) query += `&tags=${q.tags}`
    //   return query
    // },
    onScroll() {
      setTimeout(() => {
        const top = document.getElementById('app').getBoundingClientRect().top * -1
        this.offsetTop = top
      })
    }
    // async onApply(filters) {
    //   await this.$store.dispatch('photos/resetEliteGallery')
    //   await this.$store.dispatch('photos/setFilters', filters)
    //   this.current = 0
    //   const data = {
    //     current: this.current,
    //     status: 'elite',
    //     from: 'elite'
    //   }
    //   try {
    //     this.loading = true
    //     await this.$store.dispatch('photos/getPhotos', data)
    //     const date = new Date()
    //     await this.$store.dispatch(
    //       'photos/setEliteGalleryLoadDate',
    //       moment(date)
    //     )
    //   } catch (error) {
    //     this.$asa.appInsights('Pages: albums/index.vue - method: onApply', error)
    //   } finally {
    //     this.loading = false
    //   }
    // }
  }
}
</script>

<style scoped>
.album-thumbnail {
  border-radius: 4px 4px 0 0;
}
</style>
